export const initialIntegrationCategories = [
  {
    name: 'CRM & Sales',
    items: [
      {
        name: 'Salesforce',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f9/Salesforce.com_logo.svg',
        connected: false,
        key: 'salesforce',
      },
      {
        name: 'HubSpot',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/3/3f/HubSpot_Logo.svg',
        connected: false,
        key: 'hubspot',
      },
      {
        name: 'Pipedrive',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/5/5d/Pipedrive_Logo.svg',
        connected: false,
        key: 'pipedrive',
      },
      {
        name: 'Zoho CRM',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/3/30/ZOHO_logo_2023.svg',
        connected: false,
        key: 'zoho',
      },
    ],
  },
  {
    name: 'HR & People',
    items: [
      {
        name: 'Workday',
        logo: '/integrations/workday.svg',
        connected: false,
        key: 'workday',
      },
      {
        name: 'Deel',
        logo: '/integrations/deel.png',
        connected: false,
        key: 'deel',
      },
      {
        name: 'Rippling',
        logo: '/integrations/rippling.jpeg',
        connected: false,
        key: 'rippling',
      },
      {
        name: 'Gusto',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/0/03/Gusto%2C_Inc._logo.svg',
        connected: false,
        key: 'gusto',
      },
      {
        name: 'BambooHR',
        logo: '/integrations/bamboohr.png',
        connected: false,
        key: 'bamboohr',
      },
      {
        name: 'Combo',
        logo: '/integrations/Combo-Logo.svg',
        connected: false,
        key: 'combo',
      },
      {
        name: 'Silae',
        logo: '/integrations/silae.svg',
        connected: false,
        key: 'silae',
      },
      {
        name: 'Mega Pay',
        logo: '/integrations/megapay.svg',
        connected: false,
        key: 'megapay',
      },
    ],
  },
  {
    name: 'Calendar & Scheduling',
    items: [
      {
        name: 'Calendly',
        logo: '/integrations/calendly.png',
        connected: false,
        key: 'calendly',
      },
      {
        name: 'Google Calendar',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a5/Google_Calendar_icon_%282020%29.svg',
        connected: false,
        key: 'google-calendar',
      },
      {
        name: 'Microsoft Outlook',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/4/45/Microsoft_Office_Outlook_%282018%E2%80%932024%29.svg',
        connected: false,
        key: 'outlook',
      },
      {
        name: 'Acuity',
        logo: '/integrations/acuity-scheduling.png',
        connected: false,
        key: 'acuity',
      },
    ],
  },
  {
    name: 'Project Management',
    items: [
      {
        name: 'Monday',
        logo: '/integrations/monday.png',
        connected: false,
        key: 'monday',
      },
    ],
  },
  {
    name: 'Cloud & Storage',
    items: [
      {
        name: 'SharePoint',
        logo: '/integrations/sharepoint.svg',
        connected: false,
        key: 'sharepoint',
      },
      {
        name: 'Google Workspace',
        logo: '/integrations/google-workspace.svg',
        connected: false,
        key: 'google-workspace',
      },
      {
        name: 'AWS',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg',
        connected: false,
        key: 'aws',
      },
      {
        name: 'Azure',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a8/Microsoft_Azure_Logo.svg',
        connected: false,
        key: 'azure',
      },
      {
        name: 'Google Cloud',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/5/51/Google_Cloud_logo.svg',
        connected: false,
        key: 'google-cloud',
      },
      {
        name: 'Dropbox',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/c/cb/Dropbox_logo_2017.svg',
        connected: false,
        key: 'dropbox',
      },
    ],
  },
  {
    name: 'Marketing',
    items: [
      {
        name: 'Mailchimp',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/e/e4/MailChimp.svg',
        connected: false,
        key: 'mailchimp',
      },
      {
        name: 'Marketo',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b5/Marketo_logo.svg',
        connected: false,
        key: 'marketo',
      },
      {
        name: 'Klaviyo',
        logo: '/integrations/klaviyo.svg',
        connected: false,
        key: 'klaviyo',
      },
      {
        name: 'Segment',
        logo: '/integrations/segmentlogo.svg',
        connected: false,
        key: 'segment',
      },
    ],
  },
  {
    name: 'Recruiting',
    items: [
      {
        name: 'LinkedIn',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b1/LinkedIn_Logo_2013_%282%29.svg',
        connected: false,
        key: 'linkedin',
      },
      {
        name: 'Greenhouse',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/3/33/GREENHOUSE_WORDMARK_GREEN.svg',
        connected: false,
        key: 'greenhouse',
      },
      {
        name: 'Lever',
        logo: '/integrations/lever.png',
        connected: false,
        key: 'lever',
      },
      {
        name: 'Indeed',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Indeed_logo.png',
        connected: false,
        key: 'indeed',
      },
    ],
  },
  {
    name: 'ERP & Finance',
    items: [
      {
        name: 'NetSuite',
        logo: '/integrations/netsuite.png',
        connected: false,
        key: 'netsuite',
      },
      {
        name: 'QuickBooks',
        logo: '/integrations/quickbooks-2.svg',
        connected: false,
        key: 'quickbooks',
      },
      {
        name: 'Xero',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/5/57/Xero-logo-hires-RGB.png',
        connected: false,
        key: 'xero',
      },

      {
        name: 'Sage',
        logo: '/integrations/sagex3.png',
        connected: false,
        key: 'sage',
      },
      {
        name: 'Pennylane',
        logo: '/integrations/PennyLaneLogo.png',
        connected: false,
        key: 'pennylane',
      },
      {
        name: 'AppFolio',
        logo: '/integrations/appfolio.svg',
        connected: false,
        key: 'appfolio',
      },
    ],
  },
  {
    name: 'E-commerce',
    items: [
      {
        name: 'Shopify',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0e/Shopify_logo_2018.svg',
        connected: false,
        key: 'shopify',
      }
    ],
  }
];
//example of an email talking about the product Credit Cards and the cost center Cybersecurity and Financial Risk
//acuity,
